// extracted by mini-css-extract-plugin
export default {"drawerForm":"style_drawerForm__opNaY","formContent":"style_formContent__ulAzE"};